import { Requester } from './Requester';

// Types
import { IUser } from '../types';

export const GetCurrentUser = async (): Promise<IUser | false> => {
    try {
        const response = await Requester<IUser>({
            path: `users/self`,
            method: 'GET'
        });

        return '_id' in response ? response : false;
    } catch (e) {
        console.error('Get current user request failed');
        return Promise.reject(e);
    }
};
